export enum EModes {
	SIGN_IN = 'signin',
	SIGN_UP = 'signup',
}
